import { render, staticRenderFns } from "./TaskNode.vue?vue&type=template&id=0dade20a&scoped=true"
import script from "./TaskNode.vue?vue&type=script&lang=js"
export * from "./TaskNode.vue?vue&type=script&lang=js"
import style0 from "./TaskNode.vue?vue&type=style&index=0&id=0dade20a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dade20a",
  null
  
)

export default component.exports